<template>
    <div>
      <loadingcomp
        v-bind:mesaj="loadingmesaj"
        v-model="loadingvmodel"
      ></loadingcomp>
      <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
  
      <v-dialog
        persistent
        max-width="700px"
        v-model="dialog"
        @keydown.esc="cancel"
      >
        <v-card>
          <v-card-title style="background-color: #01579b">
            <span class="headline white--text">Defter Silme Yetkisi Aç</span>
          </v-card-title>
          <v-card-text class="pa-4">
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-form ref="referansbirlestir">
                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>
                        <blockquote>
                          Defter Silme Yetkisi Aç İşlemi Yapılacaktır. İşleme Devam Edilmesini İstiyor musunuz..?
                         </blockquote>
                        
                      </v-flex>
                     
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md6>
                        <v-text-field
                  label="Güvenlik Kodu"
                  v-model="guvenlikKodu"
                ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md6>
                        <tarihcomp
                          etiket="Başlangıç Tarihi"
                          v-bind:detaygizle="true"
                          v-bind:defaultvalue="'no'"
                          v-model="baslangicTarihi"
                        >
                        </tarihcomp>
                      </v-flex>
                      <v-flex xs12 sm12 md6>
                        <tarihcomp
                          etiket="Bitiş Tarihi"
                          v-bind:detaygizle="true"
                          v-bind:defaultvalue="'no'"
                          v-model="bitisTarihi"
                        >
                        </tarihcomp>
                      </v-flex>
              </v-layout>
                   
                  </v-flex>
                </v-form>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click.native="close()">{{
              $t("cancel_button")
            }}</v-btn>
            <v-btn color="primary darken-1" text @click.native="makeChange()">
              {{ $t("save_button") }}
            </v-btn>
          
          </v-card-actions>
        </v-card>
      </v-dialog>
  
     
    </div>
  </template>
  
  <script>
 
  import tarihcomp from "@/components/app/customcomp/tarihim";
  import auth from "../../../../../api/auth";
  import loadingcomp from "@/components/app/customcomp/loadingcomp";
  import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
  
  export default {
    data() {
      return {
        dovizsayristir:0,
        baslangicTarihi:"",
        bitisTarihi:"",
        guvenlikKodu:"",
        dialog: false,
        credentials: JSON.parse(window.localStorage.getItem("credentials")),
        loadingvmodel: false,
        text1: null,
        snackbar: false,
        loadingmesaj: "İşlem.."
      };
    },
    components: {
      
      loadingcomp,
      snackbarcomp,
      tarihcomp
    },
    methods: {
        close()
        {
           this.dialog=false;
        },
      makeChange() {
       
        this.loadingvmodel = true
        let Params = {
          Password  :this.guvenlikKodu,
          DateStart:this.baslangicTarihi,
          DateEnd : this.bitisTarihi,
          UserID:this.credentials.UserID,
          CompanyID : this.credentials.MuhasebeSirketNo,
      };
          this.$http.post(auth.API_URL + 'api/AccountingParameters/GiveDeleteBookPerm', Params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
  
            this.loadingvmodel = false
            this.text1 =  response.body.ResponseMessage;
            this.snackbar =true;
  
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service-'
              this.snackbar =true;
              this.loadingvmodel = false
            } else {
              this.text1 = 'Service-'
              this.snackbar =true;
              this.loadingvmodel = false
            }
          })
        
         
          this.controlDialog = false;
          this.dialog=false;
      },
      open() {
        this.dialog = true;
      },
     
    },
  };
  </script>
  
  <style>
  </style>
  